<template>
  <rank-vue :backgroundImage="backgroundImage" />
</template>
<script>
import RankVue from '@/components/common-contribute-activity/rank.vue';
import backgroundImage from './images/rank.jpg';

export default {
  name: 'ContributeScorpioRank',
  components: {
    RankVue
  },
  props: {},
  data() {
    return { backgroundImage };
  },
  watch: {},
  computed: {},
  methods: {}
};
</script>
<style lang="scss" scoped></style>
